import React, { useState, useEffect } from "react";
import DetailsEnquiryModal from "./DetailsEnquiryModal";
import FlightIcon from '../../../assets/images/package_flightIco.svg';
import HotelIcon from '../../../assets/images/package_htlIco.svg';
import TransferIcon from '../../../assets/images/package_transfers_icon.svg';
import ActivityIcon from '../../../assets/images/package_activity_icon.svg';
import CalenderIcon from '../../../assets/images/pack_calendar.svg';
import FareCategoryIcon from '../../../assets/images/pkg-fare-catgry.png';

const FareAndEnquirySection = ({ packageDetails, fareKey, resourceKeys }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const toggleModalState = () => {
      if (isModalOpen) {
        document.body.style.overflow = "hidden";
  
        if (!document.querySelector(".modal-backdrop")) {
          const backdrop = document.createElement("div");
          backdrop.className = "modal-backdrop fade show";
          document.body.appendChild(backdrop);
        }
      } else {
        document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
        document.body.style.overflow = "";
      }
    };
  
    toggleModalState();

    return () => {
      document.body.style.overflow = "";
      document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
    };
  }, [isModalOpen]);
  


  return (
    <>
      <div className="col-lg-4 col-md-12">
<div className="box_wrap common_bdrBtm">
  <div className="spfare_box p-0 border-0">
    <h4>{resourceKeys.trip_fare || "Trip Fare"}</h4>
  </div>
  <div className="base_fare_wrp sp_fare_wrp">
    <ul>
      {packageDetails?.FareDetails?.FareSplits?.Flight && (
        <li className="d-flex justify-content-between align-items-center">
          <span>{resourceKeys.flight || "Flight"}</span>
          <span>
          <span>
            {packageDetails?.FareDetails?.Currency}  </span> <span>{packageDetails?.FareDetails?.FareSplits?.Flight}
          </span> </span>
        </li>
      )}
      {packageDetails?.FareDetails?.FareSplits?.Hotel && (
        <li className="d-flex justify-content-between align-items-center">
          <span>{resourceKeys.hotel || "Hotel"}</span>
          <span>
          <span>
            {packageDetails?.FareDetails?.Currency}</span>  <span>{packageDetails?.FareDetails?.FareSplits?.Hotel}
          </span>
          </span>
        </li>
      )}
      {packageDetails?.FareDetails?.FareSplits?.Transfers && (
        <li className="d-flex justify-content-between align-items-center">
          <span>{resourceKeys.transfer || "Transfer"}</span>
          <span>
          <span>
            {packageDetails?.FareDetails?.Currency}</span>  <span>{packageDetails?.FareDetails?.FareSplits?.Transfers}
          </span>
          </span>
        </li>
      )}
      {packageDetails?.FareDetails?.FareSplits?.Activities && (
        <li className="d-flex justify-content-between align-items-center">
          <span>{resourceKeys.activity || "Activity"}</span>
          <span>
          <span>
            {packageDetails?.FareDetails?.Currency}</span>  <span>{packageDetails?.FareDetails?.FareSplits?.Activities}
          </span>
          </span>
        </li>
      )}
      {/* {packageDetails?.FareDetails?.ServiceFee > 0 && ( */}
        <li className="d-flex justify-content-between align-items-center bor_tb">
          <span>{resourceKeys.service_chrgs || "Service Charges"}</span>
          <span>
          <span>
            {packageDetails?.FareDetails?.Currency}  </span>  <span>{packageDetails?.FareDetails?.ServiceFee}
          </span>
          </span>
        </li>
      {/* )} */}
      {packageDetails?.FareDetails?.Total && (
        <li className="total_fare d-flex justify-content-between align-items-center">
          <span>{resourceKeys.Total || "Total"}</span>
          <span>
          <span className="amt">
            <span className="kwd">{packageDetails?.FareDetails?.Currency}</span>{" "}
            {packageDetails?.FareDetails?.Total}
          </span>
          </span>
        </li>
      )}
    </ul>
  </div>

  <div className="d-flex align-items-center justify-content-between fare-book">
    <button
      type="button" 
      className="theme_btnStyle packEnquiry"
      onClick={openModal}
    >
      {resourceKeys.enquiry_now || "Enquiry Now"}
    </button>
    <div className="trip-includes d-flex align-items-center justify-content-between ml-2">
      <span>{resourceKeys.Includes || "Includes"}:</span>
      
       <ul className="trip-includes-icons d-flex align-items-center">
        {packageDetails?.Features?.Includes.includes("Flight") && (
          <li>
            <img src={FlightIcon} alt="Flight" />
          </li>
        )}
        {packageDetails?.Features?.Includes.includes("Hotel") && (
          <li>
            <img src={HotelIcon} alt="Hotel" />
          </li>
        )}
        {packageDetails?.Features?.Includes.includes("Transfers") && (
          <li>
            <img src={TransferIcon} alt="Transfers" />
          </li>
        )}
        {packageDetails?.Features?.Includes.includes("Activities") && (
          <li>
            <img src={ActivityIcon} alt="Activities" />
          </li>
        )}
      </ul>
    </div>
  </div> 
  <div className="base_fare_wrp">
    <div className="trip-period d-flex align-items-center">
      <img src={CalenderIcon} alt="Period" />
      <div className="trip-period-details">
        <h4>{resourceKeys.Period || "Period"}</h4>
        <p>
          {packageDetails?.Criteria?.ValidFrom || null} -{" "} 
          {packageDetails?.Criteria?.ValidTo || null}
        </p>
      </div>
    </div>
    <div className="trip-period d-flex align-items-center">
      <img src={FareCategoryIcon} alt="Category" />
      {packageDetails?.BasicInfo?.Category?.[0]?.Name && (
        <div className="trip-period-details">
          <h4>{resourceKeys.category || "Category"}</h4>
          <p>{packageDetails?.BasicInfo?.Category?.[0]?.Name}</p>
        </div>
      )}
    </div>
  </div>
</div>
        </div>

        {isModalOpen && (
        <DetailsEnquiryModal
            closeModal={closeModal}
            packageDetails={packageDetails}
            fareKey={fareKey}
            resourceKeys={resourceKeys}
        />
        )}
    </>
  );
};

export default FareAndEnquirySection;
